module.exports = __webpack_public_path__ + "static/media/bclions.a150f2f6.jpg";